'use client'

import { cn } from '@/lib/utils'
import { useStoreI18n } from '@/store'
import { Typo3Image } from '@/types'
import { BaseLink, CardDate, Chip, Title } from '@/ui/components'
import { BaseLinkProps } from '@/ui/components/Base/type'
import { generateAltText } from '@/utils'
import { MEDIA } from '@spot'
import { memo, useMemo } from 'react'
import Img from '../Img/Img'

interface CardEventProps extends BaseLinkProps {
  title?: string
  subTitle?: string
  image?: Typo3Image
  link?: BaseLinkProps
  cardDate?: string
  date?: string
  location?: string
  isTopEvent?: boolean
}

const CardEvent = ({
  title,
  subTitle,
  image,
  link,
  className,
  cardDate,
  location,
  isTopEvent,
  date,
  ...props
}: CardEventProps) => {
  //const D = useStoreI18n.use.dictionary()
  const currentLocale = useStoreI18n.use.currentLocale()

  const imageAlt = useMemo(
    () => generateAltText('story', title, subTitle, currentLocale),
    [title, subTitle, currentLocale]
  )

  return (
    <BaseLink {...link} nextLink={true} {...props}>
      <div
        className={cn(
          'group bg-accent-400 relative h-full text-neutral-100 md:flex md:flex-col',
          className
        )}
      >
        <div className={'aspect-rect relative bg-neutral-200'}>
          {isTopEvent === true && (
            <div className="pl-xs pb-xs bg-accent-300 absolute top-0 right-0 z-10">
              <Chip
                variant="topEvent"
                size="s"
                iconLeft="material-symbols:star"
              >
                Top Event
              </Chip>
            </div>
          )}
          {image && (
            <Img
              data={image}
              alt={imageAlt}
              objectCover
              crop={{
                width: 442,
                height: 248
              }}
              fill
              className={'h-full w-full'}
              hoverGroupEffect
              sizes={`${MEDIA.tablet} 45rem`}
              quality={90}
            />
          )}

          <CardDate mode="inverted" className="absolute bottom-0 left-0 z-10">
            {cardDate}
          </CardDate>
        </div>

        <div className={'p-md'}>
          <div className="gap-y-sm flex flex-col">
            <Title as="h3" className={'h4 line-clamp-3'}>
              {title}
            </Title>
            <div className="textstyle-md-regular line-clamp-3">
              {location && <p>{location}</p>}
              {date && <p>{date}</p>}
            </div>
          </div>
        </div>
      </div>
    </BaseLink>
  )
}

CardEvent.displayName = 'CardEvent'

export default memo(CardEvent)
